export const defaultCurrency = 'EUR';

export const SUPPORTED_CURRENCY_LIST = [
  defaultCurrency,
  'CAD',
  'CHF',
  'GBP',
  'MAD',
  'USD',
  'XPF',
];

export const FRENCH_COUNTRIES = ['FR', 'CORSE', 'MQ', 'RE', 'GP', 'GF'];

export const MAP_TOKEN =
  'pk.eyJ1IjoibWFwYWRvIiwiYSI6ImNra3k1a2UwNzF4bXoyb3BsY2Jncm1uZWsifQ.ee2nB5QO7Klm8sDSkIV1iw';

export const MAPADO_API_CLIENT_ID =
  '233_4o3ymtclkcys8gk4w04g4gooscskgsg0c4ws0ooooco884048c';

export const SCOPES = [
  'crm:customers:read',
  'crm:customers:write',
].join(' ');

export const SENTRY_DSN =
  'https://8c11fa00e15141828bc9539378aac3cf@sentry.mp.waays.eu/4';

export const NOT_ON_SALE_BOOKABLE_STOCK = 'bookableStock';
export const NOT_ON_SALE_START_DATE = 'startDate';
export const NOT_ON_SALE_SALE_START_DATE = 'saleStartDate';
export const NOT_ON_SALE_SALE_END_DATE = 'saleEndDate';
export const NOT_ON_SALE_EVENT_DATE = 'eventDate';
export const NOT_ON_SALE_STATUS = 'status';
export const NOT_ON_SALE_CONTRACT = 'contract';

export const BYPASS_NOT_ON_SALE_REASONS = [
  NOT_ON_SALE_BOOKABLE_STOCK,
  NOT_ON_SALE_START_DATE,
  NOT_ON_SALE_SALE_START_DATE,
  NOT_ON_SALE_SALE_END_DATE,
  NOT_ON_SALE_EVENT_DATE,
];

export const FETCH_STATUS_NOT_STARTED = 'NOT_STARTED';
export const FETCH_STATUS_IN_PROGRESS = 'IN_PROGRESS';
export const FETCH_STATUS_SUCCEEDED = 'SUCCEEDED';
export const FETCH_STATUS_FAILED = 'FAILED';

export const OFFER_CURRENT_SCHEMA_VERSION = 2;

const STRIPE_PROD_CLIENT_ID = 'ca_7HG0LT7YIkOUR1WpTzb0AQs9QUZdBRhi';
const STRIPE_DEV_CLIENT_ID = 'ca_7HG0H1eFICxvNEuOsnWeB7YScVllkeCi';

let deskDomain = 'desk.mapado.com';

if (process.env.NODE_ENV !== 'production') {
  deskDomain = 'desk.preprod.mapado.com';

  if (process.env.VADER_USER) {
    deskDomain = `desk.${process.env.VADER_USER}.dev.mapado.com`;
  }
}

export const STRIPE_OAUTH_URL = `https://connect.stripe.com/oauth/authorize?response_type=code&scope=read_write&client_id=${
  process.env.NODE_ENV === 'production'
    ? STRIPE_PROD_CLIENT_ID
    : STRIPE_DEV_CLIENT_ID
}&redirect_uri=https://${deskDomain}/onboarding`;

export const HERE_API_KEY = '4RbyexiG50ESaPpRZ9OtwMrtOwQdrtebZ1NyPsUpk0Y';

export const OPENREPLAY_PROJECT_KEY = 'GvG4TtTGojTo4nwdmzkM';
